/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdPersonOutline, MdBadge, MdErrorOutline, MdArrowForward, MdGpsFixed, MdSchedule, MdAnalytics, MdDirectionsBus, MdAltRoute, MdLocationOn, MdDepartureBoard, MdMap, MdMyLocation } from "react-icons/md";
import useAuth from "../../hooks/useAuth";
import logoCompleta from "../../assets/images/logo_completa_branca.png";
import logoSmall from "../../assets/images/logo_small_branca.png";
import {
  LoginScreen, LoginBg, LoginGrid, LoginRoutes, RouteLine, RouteDotEl,
  FloatIcons, FloatIcon, LoginLayout, BrandPanel, BrandLogo, BrandTagline,
  BrandDesc, BrandFeatures, BrandFeature, BrandFeatureIcon,
  FormPanel, LoginCard, CardLogo, LoginHeader, IconBadge, LoginTitle,
  LoginSubtitle, FormGroup, FormLabel, FormInputWrapper, FormInput,
  FormInputIcon, FormError, BtnLogin, LoginDivider, LoginFooter,
  FooterText, FooterBrand,
} from "./styled";

const Login = () => {
  const { signin } = useAuth();
  const navigate = useNavigate();
  const [matricula, setMatricula] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (!matricula) {
      setError("Preencha o campo de matrícula");
      return;
    }

    setLoading(true);
    signin(matricula);

    const loginError = localStorage.getItem("error");
    if (loginError) {
      setError(loginError);
      setLoading(false);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('token')) navigate("/");
  }, []);

  return (
    <LoginScreen>
      <LoginBg />
      <LoginGrid />
      <LoginRoutes>
        <RouteLine top="18%" duration="12s" />
        <RouteLine top="42%" duration="16s" delay="-4s" />
        <RouteLine top="75%" duration="10s" delay="-2s" />
        <RouteDotEl top="18%" duration="12s" />
        <RouteDotEl top="42%" duration="16s" delay="-4s" green />
        <RouteDotEl top="75%" duration="10s" delay="-2s" />
      </LoginRoutes>
      <FloatIcons>
        <FloatIcon as={MdDirectionsBus} top="8%" left="5%" delay="0s" />
        <FloatIcon as={MdAltRoute} top="15%" right="8%" delay="-5s" size="36px" green />
        <FloatIcon as={MdLocationOn} bottom="20%" left="10%" delay="-10s" size="42px" />
        <FloatIcon as={MdDepartureBoard} bottom="12%" right="12%" delay="-3s" size="32px" green />
        <FloatIcon as={MdMap} top="50%" left="3%" delay="-7s" size="28px" />
        <FloatIcon as={MdMyLocation} top="35%" right="5%" delay="-12s" size="38px" />
      </FloatIcons>

      <LoginLayout>
        <BrandPanel>
          <BrandLogo src={logoCompleta} alt="SS Telemática" />
          <BrandTagline>
            <span>Acompanhamento de viagens em tempo real</span>
          </BrandTagline>
          <BrandDesc>
            Monitore frotas, acompanhe rotas e horários com precisão. Tudo em uma única plataforma.
          </BrandDesc>
          <BrandFeatures>
            <BrandFeature>
              <BrandFeatureIcon><MdGpsFixed /></BrandFeatureIcon>
              <span>Rastreamento</span>
            </BrandFeature>
            <BrandFeature>
              <BrandFeatureIcon><MdSchedule /></BrandFeatureIcon>
              <span>Horários</span>
            </BrandFeature>
            <BrandFeature>
              <BrandFeatureIcon><MdAnalytics /></BrandFeatureIcon>
              <span>Monitoramento</span>
            </BrandFeature>
          </BrandFeatures>
        </BrandPanel>

        <FormPanel>
          <LoginCard>
            <CardLogo>
              <img src={logoCompleta} alt="SS Telemática" />
            </CardLogo>

            <LoginHeader>
              <IconBadge><MdPersonOutline size={28} /></IconBadge>
              <LoginTitle>Bem-vindo</LoginTitle>
              <LoginSubtitle>Acesse o painel de acompanhamento</LoginSubtitle>
            </LoginHeader>

            <form onSubmit={handleLogin}>
              <FormGroup>
                <FormLabel htmlFor="matricula">Matrícula do colaborador</FormLabel>
                <FormInputWrapper>
                  <FormInput
                    id="matricula"
                    type="text"
                    placeholder="Ex: 12345"
                    autoComplete="off"
                    value={matricula}
                    error={!!error}
                    onChange={(e) => { setMatricula(e.target.value); setError(''); }}
                    aria-describedby="matricula-error"
                  />
                  <FormInputIcon><MdBadge size={20} /></FormInputIcon>
                </FormInputWrapper>
                <FormError visible={!!error} id="matricula-error" role="alert">
                  <MdErrorOutline size={16} />
                  <span>{error}</span>
                </FormError>
              </FormGroup>
              <BtnLogin type="submit" disabled={loading}>
                <span>{loading ? 'Entrando...' : 'Entrar'}</span>
                {!loading && <MdArrowForward size={20} />}
              </BtnLogin>
            </form>

            <LoginDivider>Acompanhamento de Viagens</LoginDivider>

            <LoginFooter>
              <FooterText>Plataforma de monitoramento</FooterText>
              <FooterBrand>
                <img src={logoSmall} alt="SS" />
                <span>SS Telemática</span>
              </FooterBrand>
            </LoginFooter>
          </LoginCard>
        </FormPanel>
      </LoginLayout>
    </LoginScreen>
  );
};

export default Login;
